export default "__VITE_ASSET__1tLIYboi__"